import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { getExperienceCoverImage } from "../helpers"
import { describeBookingDateLines } from "../bookingDescription"
import { BOOKING_REQUESTED_STATUS } from "../constants"
import BookingSuccessActions from "./BookingSuccessActions"
import styles from "./WidgetCheckout.module.css"

const BookedRow = ({ booking, experience, selection }) => {
  const { t } = useTranslation()
  const coverImage = getExperienceCoverImage(experience)
  return (
    <Flex align="center" justify="space-between" gap={16} wrap="wrap" className={styles.bookedRow}>
      <Flex align="center" gap={12} className={styles.bookedInfo}>
        <div className={styles.summaryImage}>{coverImage && <img src={coverImage} alt={experience?.title} />}</div>
        <Flex vertical gap={2}>
          <span className={styles.summaryTitle}>{experience?.title}</span>
          <span className={styles.bookedMeta}>{describeBookingDateLines({ experience, selection, t }).join(" · ")}</span>
          {booking.bookingId && <span className={styles.bookedMeta}>{t("booking_widget.success.booking_id", { id: booking.bookingId })}</span>}
          {booking.status === BOOKING_REQUESTED_STATUS && <span className={styles.awaitingApproval}>{t("booking_widget.success.awaiting_approval")}</span>}
        </Flex>
      </Flex>
      <BookingSuccessActions booking={booking} justify="flex-start" />
    </Flex>
  )
}

BookedRow.propTypes = {
  booking: PropTypes.shape({ bookingId: PropTypes.string, status: PropTypes.string }).isRequired,
  experience: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired
}

// The success screen after paying for several experiences: each booking with its date, its own
// booking ID and its own Sign Waiver / Answer Questions, and "Awaiting the guide's approval" on a
// request (a booking within 24 hours the guide hasn't accepted yet). No design yet (client question 53).
const BookedOrderList = ({ bookings }) => (
  <Flex vertical gap={12} className={styles.bookedList}>
    {bookings.map(({ key, booking, experience, selection }) => (
      <BookedRow key={key} booking={booking} experience={experience} selection={selection} />
    ))}
  </Flex>
)

BookedOrderList.propTypes = {
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      booking: PropTypes.object.isRequired,
      experience: PropTypes.object.isRequired,
      selection: PropTypes.object.isRequired
    })
  ).isRequired
}

export default BookedOrderList
